import { Grid2 } from "@mui/material";
import { AdminNav } from "../../layout/navs";
import { CardItem } from "./CardItem";
import { NavItem } from "../../layout/navs/AdminNav";

export const Dashboard = () => {
  return (
    <Grid2 container>
      {AdminNav.map((item: NavItem) => {
        return (
          item.id !== 1 && (
            <CardItem
              key={item.id}
              title={item.title}
              description={item.description}
              icon={item.icon}
              bgColor={`var(--color-${item.themeColor}-light)`}
              iconColor={`var(--color-${item.themeColor}-main)`}
              textColor={`var(--color-${item.themeColor}-main)`}
              navigateTo={item.path}
            />
          )
        );
      })}
    </Grid2>
  );
};
